@if (location) {
  <div class="location-banner">
    <div class="banner-content">
      <svg class="pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <span class="location-label">
        Showing results near <strong>{{ location.city }}, {{ location.state }}</strong>
      </span>
      <div class="radius-control">
        <label for="radius-select">within</label>
        <select
          id="radius-select"
          [value]="location.radius"
          (change)="onRadiusChange($event)"
          class="radius-select"
          title="Search radius"
        >
          @for (r of radiusOptions; track r) {
            <option [value]="r" [selected]="r === location.radius">{{ r }} mi</option>
          }
        </select>
      </div>
    </div>
  </div>
} @else {
  <div class="location-prompt">
    <div class="prompt-content">
      <svg class="pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
        <circle cx="12" cy="10" r="3"></circle>
      </svg>
      <p class="prompt-text">
        Share your location to discover classes, events, and workshops near you
      </p>
      <button
        type="button"
        class="allow-btn"
        (click)="detectLocation()"
        [disabled]="isDetecting"
      >
        @if (isDetecting) {
          <span class="btn-spinner"></span> Detecting...
        } @else {
          Allow Location Access
        }
      </button>
      <span class="prompt-hint">or enter your city in the search above</span>
      @if (detectError) {
        <p class="prompt-error">{{ detectError }}</p>
      }
    </div>
  </div>
}
